// extracted by mini-css-extract-plugin
module.exports = {"alertContainer":"Banner_alertContainer__LeNkc","alert":"Banner_alert__2pbiw","closebtn":"Banner_closebtn__17Cys"};